// extracted by mini-css-extract-plugin
export var actionText = "_nx-4";
export var container = "_nx-0";
export var leftSection = "_nx-1";
export var rightSection = "_nx-2";
export var settingsButton = "_nx-6";
export var settingsIcon = "_nx-7";
export var shortcut = "_nx-5";
export var shortcutGroup = "_nx-3";